









































import { Component, Vue, Ref, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";

import TeacherForm from "@/components/TeacherForm/TeacherForm.vue";

import { Action, State } from "vuex-class";
import { IVuexState } from "@/models/interfaces/store";

import { AxiosResponse } from "axios";

import RequestState from "@/utils/mixins/RequestState";

import { ITeacher, ITeacherPayload } from "@/models/interfaces/teachers";
import { equals, reject } from "ramda";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

interface TeacherFormType {
  setLoadingState: (state: boolean) => void;
}

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    TeacherForm,
    BasePopup,
    BaseButton,
    BaseSpinner,
    BaseAlert
  }
})
export default class TeacherEditView extends Mixins(RequestState) {
  @Ref("form")
  private form!: HTMLFormElement & TeacherFormType;

  @State("teacher", { namespace: "teachers" })
  private teacher!: IVuexState<ITeacher>;

  @Action("teachers/editTeacher")
  private editTeacher!: (data: {
    payload: ITeacherPayload;
    teacherId: string;
  }) => Promise<AxiosResponse>;

  @Action("teachers/fetchTeacherById")
  private fetchTeacherById!: (teacherId: string) => Promise<AxiosResponse>;

  private showValidationPopup = false;
  private popupMessage = "";
  private redirectOnPopupClose = false;
  private popupTimeout!: number;

  private showPopup(message: string) {
    this.popupMessage = message;
    this.showValidationPopup = true;
  }

  private onPopupClose() {
    this.showValidationPopup = false;

    if (this.redirectOnPopupClose) {
      amplitude
        .getInstance()
        .logEvent(
          `${eventCodeByName(
            EventsNames.UserClicksOkOnPopupAfterTeacherEdit
          )} ${EventsNames.UserClicksOkOnPopupAfterTeacherEdit}`
        );

      this.popupTimeout = window.setTimeout(() => {
        this.$router.push("/teachers");
      }, 500);
    }
  }

  private onEditTeacher(form: ITeacherPayload) {
    this.form.setLoadingState(true);

    const clearedForm = reject(equals(""))(form) as ITeacherPayload;

    this.editTeacher({
      payload: clearedForm,
      teacherId: this.$route.params.teacherId
    })
      .then(() => {
        this.popupMessage = this.$t("views.teachers.messages.update") as string;
        this.showValidationPopup = true;
        this.redirectOnPopupClose = true;
      })
      .finally(() => {
        this.form.setLoadingState(false);
      });
  }

  public mounted() {
    const { teacherId } = this.$route.params;
    this.fetchTeacherById(teacherId);
  }

  public beforeDestroy() {
    window.clearTimeout(this.popupTimeout);
  }
}
